module.exports = "<p>\n  order-details works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// E:/Project/posSystem/src/app/pos/home/order/order-details/order-details.component.html
// module id = ../../../../../src/app/pos/home/order/order-details/order-details.component.html
// module chunks = main